export enum UploadModalStatus {
  Loading = 'Loading',
  Completed = 'Completed',
  Failed = 'Failed',
}
